/* src/app/workshop/components/workshop-vehicles/vehicle-new/vehicle-new.component.scss */
/*# sourceMappingURL=vehicle-new.component.css.map */
